export default {
  storageUrl (path: string) {
    return `${process.env.REACT_APP_API_STORAGE_URL}/${path}`
  }
}
